import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, makeStyles } from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import Datatable from 'src/shared/ui/components/Datatable';

import getEmployeeList from 'src/employee/use-cases/getEmployeeList';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const EmployeeListView = () => {
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const classes = useStyles();

  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const navigate = useNavigate();

  const fetchList = async () => {
    const employeeList = await getEmployeeList({
      companyHeadquarterId,
      search,
      orderBy: '',
      page,
      limit
    });

    setList(employeeList.rows);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/employees/${id}`, {
      replace: false
    });
  };

  const columnNameList = [
    'createdAt',
    'department',
    'firstname',
    'surnames',
    'document',
    'phone1',
    '${User.firstname}${User.surnames}${User.email}'
  ];

  return (
    <Page className={classes.root} title="Empleados">
      <Container maxWidth={false}>
        <Datatable
          domainName="EMPLOYEE"
          dataList={list}
          title="Empleados"
          addButtonText="Añadir empleado"
          addButtonRoute="/app/employees/new"
          exportExcelButton={Boolean(false)}
          onSearch={handleSearch}
          onChangePageValue={handleChangePage}
          onChangePageLimit={handleChangeLimit}
          handleClickEdit={handleClickEdit}
          columnNameList={columnNameList}
        />
      </Container>
    </Page>
  );
};

export default EmployeeListView;
